
<template>
  <el-select
    v-model="content"
    filterable
    :size="size"
    remote
    reserve-keyword
    :placeholder="selectPlaceholder"
    clearable
    v-bind="$attrs"
    :remote-method="remoteMethod"
    :loading="loading"
    class="select-search-default"
    v-on="$listeners"
    @change="change"
  >
    <el-option
      v-for="item in merchantList"
      :key="item.merchant_no"
      :label="item.merchant_no + ' ' + item.merchant_name"
      :value="item.merchant_name"
    />
  </el-select>

</template>

<script>

import { fetchMchListByAgent } from '@/api/agent-merchant/agent-merchant'
export default {
  name: 'Search_Agent_Select',
  model: {
    prop: 'value',
    event: 'updateValue'
  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    onlyName: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  data() {
    return {
      merchantList: [],
      loading: false,
      content: this.value
    }
  },
  computed: {
    selectPlaceholder() {
      return this.onlyName ? this.$t('merchant.merchant_name') : this.$t('merchant.merchant_no') + '/' + this.$t('merchant.merchant_name')
    }
  },
  watch: {
    value() {
      this.content = this.value
    }
  },
  methods: {
    remoteMethod(val) {
      this.loading = true
      fetchMchListByAgent({ merchant_name_no: val }).then(res => {
        this.merchantList = res.data || []
      }).finally(() => {
        this.loading = false
      })
    },
    change(val) {
      this.$emit('updateValue', val)
    }
  }
}
</script>
<style scoped>
/* .select-search-default{
  width: 300px;
  margin: 0 10px 24px;
} */
</style>
